export const playerConstants = {
    SET_DATA: 'SET_PLAYER_DATA',
    PUSH_RESULT: 'PUSH_PLAYER_RESULT'
};
